module.exports = __webpack_public_path__ + "static/media/icon-gear.4dd2a042.svg";